module.exports = __webpack_public_path__ + "static/media/physalina-logo.cbdb07c4.svg";